import { Profile } from 'store/user/reducer.types';

const PROFILE_NAME_EMPTY_ERROR = 'PROFILE_NAME_EMPTY_ERROR';

const PROFILE_NAME_EXISTING_PROFILE_ERROR =
    'PROFILE_NAME_EXISTING_PROFILE_ERROR';

export const nullFunction = () => null;

export const deletedProfileErrorCodesArray = [8128, 1111, 4705];

export const validateProfileName = (name: string) => {
    return name ? '' : PROFILE_NAME_EMPTY_ERROR;
};

export const validateProfileNameToExistingNames = (
    newName: string,
    profiles: Profile[],
) => {
    return profiles.some(
        ({ name }) => name.toLowerCase() === newName.toLowerCase(),
    )
        ? PROFILE_NAME_EXISTING_PROFILE_ERROR
        : '';
};
